module.exports = __webpack_public_path__ + "media/images/suppliers/revmab-6db97072224d0828f9334cf0f8c05311.png";